import React from 'react';

export default class Page7 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <table
                                                className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="20%">If you have a strong
                                                        preference for...
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="40%">You are likely to...
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg"> Experiential </span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have imagined yourself in that situation,
                                                            thinking about what
                                                            you would need from a hardware store at those
                                                            prices.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg">Observational</span></p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have adopted a slightly removed view of the
                                                            situation
                                                            overall, and thought strategically – starting
                                                            with the cost
                                                            aspect, perhaps, to work out all the different
                                                            items to
                                                            which it could apply.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Pictorial</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have imagined the situation to list everything
                                                            you thought
                                                            you’d need if you were building apartments
                                                            yourself. You may
                                                            have created a ‘mind map’ by making notes of
                                                            these thoughts
                                                            or sketching images.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">Aural</span></p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have talked out loud about the problem – to
                                                            yourself or others
                                                            to see how it sounded and if this would prompt a
                                                            solution.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">Challenging</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have sought the answer by questioning the
                                                            information; for
                                                            example, why was the cost so low, or asking
                                                            which particular
                                                            item would cost £4 for twelve?</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg">Accepting</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>have taken the information at face value and
                                                            relied on it alone,
                                                            probably concentrating on the cost as the most
                                                            helpful element
                                                            from which to discover the solution.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <p>You can see from the table above that there are many
                                                different ways to think about generating
                                                solutions. Some thought styles will feel natural to you but
                                                you can choose different methods of
                                                processing information or approaching problems. Think about
                                                the different ways you might go
                                                about solving a problem with other people – and on your
                                                own.</p>

                                            <p>The following table gives you some ideas for using different
                                                thinking styles effectively.</p>

                                            <table
                                                className="ilead_v_sport tablesrink uiheading ilead_v_sport_center"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" valign="center"
                                                        width="20%">Preference
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        valign="center" width="40%">Tips
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg">Bigger picture</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You like to come up with ideas and instructions,
                                                            so tend to produce overall
                                                            strategies and consider how they relate to wider
                                                            contexts. You could use your
                                                            ‘big picture’ thinking to help detail-focused
                                                            people put their contributions into
                                                            context – this might generate more ideas all
                                                            round, too! You could take more
                                                            time to attend to the details of a situation;
                                                            for example, try working ‘from the
                                                            inside out’ to get insights not always available
                                                            from your usual ‘overview’.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span
                                                            className="subtiltereg">Detail focused</span>
                                                        </p>
                                                    </td>

                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>Because you concentrate on the details of a
                                                            situation, you will want to understand exactly
                                                            if and how suggestions from others would work.
                                                            You can provide the details which link the
                                                            different elements of a solution, or help others
                                                            less able to focus on detail to consider
                                                            important factors they may otherwise
                                                            overlook.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%">
                                                        <p><span className="subtiltereg"> Creative</span>
                                                        </p>
                                                    </td>

                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="40%">
                                                        <p>You can think of lots of ideas and unconventional
                                                            solutions (you came up
                                                            with quite a few uses for a cardboard tube!) You
                                                            can suggest some of your
                                                            ‘wackier’ ideas which less creative people won’t
                                                            have considered, but may
                                                            need to rein in ones which are not related to
                                                            relevant information, are
                                                            impractical or ambiguous.</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}